import MarketTable from './MarketTable';

export default MarketTable;
